import React from "react";
import { PermissionContext } from "./PermissionContext";
import { hasPermission } from "../store/slices/roleSlice";
import { useSelector } from "react-redux";

export default function PermissionProvider({ children, permissions }) {
  // console.log(permissions)
  // return (
  //   <PermissionContext.Provider value={permissions}>
  //     {children}
  //   </PermissionContext.Provider>
  // );
  const user = useSelector(state => state.auth?.after_login_data?.data);
    if (!hasPermission(user, permissions)) {
        return <h2>403 - Unauthorized</h2>;
    }

    return children;
}
